import React, { useState } from "react";
import axios from "axios";
import { Send, CheckCircle2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LeadCaptureForm({ sessionId, question, onSubmitted }) {
  const [form, setForm] = useState({ name: "", email: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (busy || !form.name.trim() || !form.email.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/lead/capture`, {
        name: form.name.trim(),
        email: form.email.trim(),
        question: question || "Asked to be contacted via chat.",
        session_id: sessionId,
        source: "chat",
      });
      setDone(true);
      onSubmitted?.();
    } catch (_e) {
      // surface lightly — the chat-widget toast handles severity
      setDone(true);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="lead-capture-success"
        className="rounded-xl p-4 mt-2"
        style={{
          background: "rgba(0,240,255,0.08)",
          border: "1px solid rgba(0,240,255,0.25)",
        }}
      >
        <div className="flex items-center gap-2 text-cyan-300 text-sm font-semibold mb-1">
          <CheckCircle2 size={16} /> Sent to Lovefavor.
        </div>
        <p className="text-white/75 text-xs leading-relaxed">
          She'll get back to you personally — usually within 24 hours.
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="lead-capture-form"
      className="rounded-xl p-3 mt-2 space-y-2"
      style={{
        background: "rgba(212,175,55,0.08)",
        border: "1px solid rgba(212,175,55,0.3)",
      }}
    >
      <div className="text-[10px] tracking-[0.2em] uppercase text-[#D4AF37] font-bold">
        Forward to Lovefavor
      </div>
      <input
        data-testid="lead-name"
        type="text"
        required
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
        placeholder="Your name"
        className="w-full text-sm bg-white/5 border border-white/15 rounded-md px-3 py-2 text-white placeholder-white/40 focus:outline-none focus:border-[#D4AF37]"
      />
      <input
        data-testid="lead-email"
        type="email"
        required
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
        placeholder="Your email"
        className="w-full text-sm bg-white/5 border border-white/15 rounded-md px-3 py-2 text-white placeholder-white/40 focus:outline-none focus:border-[#D4AF37]"
      />
      <button
        data-testid="lead-submit"
        type="submit"
        disabled={busy}
        className="w-full flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.15em] py-2 rounded-md text-[#030712] disabled:opacity-50"
        style={{
          background: "linear-gradient(135deg,#D4AF37 0%,#F3CE5E 100%)",
        }}
      >
        {busy ? "Sending…" : (<>Send to Lovefavor <Send size={13} /></>)}
      </button>
    </form>
  );
}
